import React from 'react'
import ReactDOM from 'react-dom'
import { on } from 'delegated-events'
import Calculator from '@components/calculators/Calculator'
import { AppProvider } from '@components/calculators/Context'

const fn = {
  init: () => {
    on('calculatormodalopen', 'html', fn.handleOpen)
    on('modalclose', 'html', fn.handleClose)
  },

  handleOpen: (e) => {
    const type = e.detail.type
    const rootNode = document.getElementById('calculator-root')

    ReactDOM.render(
      <div className="calc-wrapper md:w-[600px] min-h-[320px]">
        <React.StrictMode>
          <AppProvider>
            <Calculator type={type} />
          </AppProvider>
        </React.StrictMode>
      </div>,
      rootNode
    )
  },

  handleClose: () => {
    const rootNode = document.getElementById('calculator-root')

    if (rootNode) {
      ReactDOM.unmountComponentAtNode(rootNode)
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
